import type { AnnotatedJsonSchema } from '@web-config-app/core';
import { isCombinatorSchema } from '../is-combinator-schema/is-combinator-schema';

export const isCombinatorArraySchema = ({ items }: AnnotatedJsonSchema) =>
  Boolean(items) && isCombinatorSchema(items as AnnotatedJsonSchema);
